import { render, staticRenderFns } from "./MediaGallery.vue?vue&type=template&id=86181ea2&scoped=true"
import script from "./MediaGallery.vue?vue&type=script&lang=ts"
export * from "./MediaGallery.vue?vue&type=script&lang=ts"
import style0 from "./MediaGallery.vue?vue&type=style&index=0&id=86181ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86181ea2",
  null
  
)

export default component.exports